import styled from "@emotion/styled";

import { DateInput, TimeInput } from "metabase/ui";

export const FlexDateInput = styled(DateInput)`
  flex: 1 1 auto;
`;

export const FlexTimeInput = styled(TimeInput)`
  flex: 1 1 auto;
`;
